const TOAST_SUCCESS_TIMEOUT = 5500;
const TOAST_DEFAULT_TIMEOUT = 60000;

export default toastType => {
  let message;
  if (toastType === 'success' || toastType === 'warning') {
    message =
      'operation(s) mapped. You can adjust crop zones via the associated application.';
  } else {
    message =
      'operation(s) were unable to be matched, contact support if issue persists.';
  }
  return message;
};

export const toastTitle = toastType => {
  let message;
  if (toastType === 'success' || toastType === 'warning') {
    message = 'Data matched to';
  } else {
    message = 'Data unable to be matched to';
  }
  return message;
};

export const toastTimeOut = toastType =>
  toastType === 'success' ? TOAST_SUCCESS_TIMEOUT : TOAST_DEFAULT_TIMEOUT;
